import { render, staticRenderFns } from "./FileCategoriesModal.vue?vue&type=template&id=5fbac49e&"
import script from "./FileCategoriesModal.vue?vue&type=script&lang=js&"
export * from "./FileCategoriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports